export enum EAdditionalService {
  Moving_Furniture = 'Moving Furniture',
  Urine_Present = 'Urine Present',
  Rotary_Extraction = 'Rotary Extraction',
  Heavy_Soiling = 'Heavy Soiling',
  Wax_Removal = 'Wax Removal',
  Rust_Removal = 'Rust Removal',
  Gum_Removal = 'Gum Removal',
}
